import React from "react";
import { useSearchParams } from "react-router-dom";
import CutoffContent from "./components/Cutoff/CutoffContent";
import RetainedNetIncome from "./components/Cutoff/RetainedNetIncome";
import CutoffViewSwitch from "./components/Cutoff/CutoffViewSwitch";

function Cutoff({ authrztn }) {
  // Active view lives in the URL (?view=retained) so returning from
  // ViewRetainedNetIncome lands back on the same view
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get("view") === "retained" ? "retained" : "cutoff";

  const setView = (value) =>
    setSearchParams(value === "retained" ? { view: "retained" } : {}, {
      replace: true,
    });

  const viewSwitch = <CutoffViewSwitch view={view} onChange={setView} />;

  return view === "retained" ? (
    <RetainedNetIncome authrztn={authrztn} viewSwitch={viewSwitch} />
  ) : (
    <CutoffContent authrztn={authrztn} viewSwitch={viewSwitch} />
  );
}

export default Cutoff;
